import {Container, Text} from "./styled";

export const Title = ({title}) => {
    return (
        <Container>
            <Text>{title}</Text>
        </Container>
    )
}